<template>
  <div class="onboarding">
    <transition :name="transitionName" mode="out-in">
      <component
        :is="componentId"
        :obj-user-setting.sync="getUserSetting"
        :title="title"
        :subTitle="subTitle"
        :imageName="imageName"
        @callback-func="onCallBack"
        @next-page="doNextPage"
      ></component>
    </transition>
    <onboarding-step
      class="onboarding__step"
      @callback-submit="onCallbackSubmit"
      :count-page="countOnboarding"
      :current-page.sync="currentPage"
    ></onboarding-step>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import {
  OnboardingGeneral,
  OnboardingLanguage,
  OnboardingInvest,
  OnboardingAsset,
  OnboardingStep
} from "../../molecules"
export default {
  components: {
    "onboarding-general": OnboardingGeneral,
    "onboarding-entrance": OnboardingGeneral,
    "onboarding-language": OnboardingLanguage,
    "onboarding-invest": OnboardingInvest,
    "onboarding-asset": OnboardingAsset,
    "onboarding-step": OnboardingStep
  },
  data() {
    return {
      currentPage: 1,
      currentComponentName: "",
      selectedLanguage: null,
      formData: [],
      transitionName: "slide"
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal, oldVal) {
        this.transitionName = oldVal > newVal ? "slide-right" : "slide-left"
      }
    }
  },
  computed: {
    ...mapGetters("onboarding", ["getUserSetting", "getOnboarding", "getUserOnboarding"]),
    countOnboarding() {
      return this.getOnboarding.length
    },
    componentId() {
      this.currentComponentName = this.getOnboarding.length ? this.getOnboarding[this.currentPage - 1].id : null
      return this.currentComponentName
    },
    title() {
      switch (this.currentComponentName) {
        case "onboarding-general":
          return "Welcome to <br/> FINNOMENA MONEY"
        case "onboarding-entrance":
          return "เข้า FINNOMENA MONEY </br> ง่ายมากกว่าเดิม"
        case "onboarding-language":
          return "เลือกภาษา"
        case "onboarding-invest":
          return "ความรู้ด้านการลงทุนของคุณ<br/>อยู่ในระดับไหน"
        case "onboarding-asset":
          return "กรุณาเรียงลำดับความสนใจของ<br/>คุณจากมากไปน้อย"
        default:
          return null
      }
    },
    subTitle() {
      switch (this.currentComponentName) {
        case "onboarding-general":
          return "เช็กราคาทอง หุ้น กองทุน ฯลฯ <br/> ดูง่าย ดูครบ จบในที่เดียว"
        case "onboarding-entrance":
          return "เพียงคุณเข้าหน้า Home บน LINE แล้วเลือก Add ในแถบ Services จากนั้นมองหา FINNOMENA MONEY เพื่อ Pin แล้วอย่าลืมกด Save"
        case "onboarding-language":
          return "ไม่รวมบทความและเนื้อหาบางส่วน"
        case "onboarding-invest":
          return "ความรู้ด้านการลงทุนของคุณ<br/>อยู่ในระดับไหน"
        case "onboarding-asset":
          return "การแสดงผลจะขึ้นอยู่กับความสนใจของคุณ"
        default:
          return null
      }
    },
    imageName() {
      switch (this.currentComponentName) {
        case "onboarding-general":
          return "onboarding-general@3x.png"
        case "onboarding-entrance":
          return "onboarding-entrance@3x.png"
        case "onboarding-invest":
          return "onboarding-invest@3x.png"
        default:
          return null
      }
    }
  },
  methods: {
    ...mapActions("onboarding", ["insertConfiguration"]),

    doNextPage(num) {
      this.currentPage += num
    },
    onCallBack(obj) {
      const { val, type } = obj
      if (type === "language") this.getUserSetting.language = val
      else if (type === "theme") this.getUserSetting.theme = val
      else if (type === "investlvl") this.getUserSetting.investlvl = val.toString()
      else if (type === "assets") this.getUserSetting.assets = val
    },
    onCallbackSubmit(obj) {
      const { page, skip } = obj
      // prepair skip data
      this.getOnboarding[page - 1].skip = skip
      // assign new onboarding to user onboarding
      this.getOnboarding.forEach(obd => {
        if (!this.getUserOnboarding.find(item => item.id == obd.id)) {
          this.getUserOnboarding.push(obd)
        }
      })
      // upsert data
      this.insertConfiguration()
      document.documentElement.style.overflow = ""
      this.$router.replace({ name: "miniapp-home" })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_Onboarding";
</style>